// ZETA VOICE タグ表示内容の調整処理
document.addEventListener('zvrendercomplete', (e) => {
  // 未処理の star-comment のみ取得
  const comments = document.querySelectorAll('.zv-star-comment:not([data-zv-handled])');

  if (comments.length != 0) {
    comments.forEach((el) => {
      el.dataset.zvHandled = "true";
      const text = el.textContent;
      if (!text) {
        return;
      }

      // jsファイル名で判定してテキストを変更
      let match = null;
      if (e.detail.js === "zv.summary_list.js") {
        // 商品一覧 レビューのサマリ(スコア)： "(〇件)" → "(〇)"
        match = text.match(/\((\d+)件?\)/);
      } else if (e.detail.js === "zv.summary.js") {
        // 商品詳細 レビューのサマリ(スコア)： "〇.〇 (〇件のレビュー)" → "(〇)"
        match = text.match(/\((\d+)件のレビュー\)/);
      }

      if (match) {
        const count = match[1];
        el.textContent = `(${count})`;
      }
    });
  }

  // 商品ごとのレビュー一覧：8件以降を非表示にする
  if (e.detail.js === 'zv.list.js') {
    const container = document.querySelector('.p-item-detail #ZVList');

    if (container) {
      const reviews = container.querySelectorAll('.zv-top-customer-review');
      for (let i = 8; i < reviews.length; i++) {
        reviews[i].style.display = 'none';
      }
    }
  }

  if (e.detail.js === 'zv.summary_list.js') {
    const comments = document.querySelectorAll('.zv-star-comment')[0];
    const review_header = document.querySelector('.p-review-header');
    if (comments) {
      const text = comments.textContent.match(/\((\d+)\)/);
      if (text) {
        const count = text[1];
        document.querySelector('.zv-total-count').textContent = count + '件';
        
        if (review_header) {
          review_header.classList.add('is-visible');
        }
      }
    }
  }
    
  // ビデオサムネイル表示（iPhone実機対応）
  const videos = document.querySelectorAll('video.zv-video');
  videos.forEach(video => {
    if (video.src && !video.src.includes('#t=')) {
      video.src = video.src + '#t=0.1';
    }
  });
});

// 投稿完了モーダルの閉じるボタンを押した場合、画面リロード
document.addEventListener('zvpostcomplete', () => {  
  const closeButton = document.querySelector('.zv-btn.zv-response-modal-close-button');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      window.location.reload();
    })
  }
});